const getters = {
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  isHome: state => state.header.isHome,
  sidebar: state => state.app.sidebar,
  userInfo: state => {
    if (state.user.userInfo === 'undefined' || state.user.userInfo === undefined) {
      return null
    }
    return JSON.parse(state.user.userInfo)
  },
  accessRoutes: state => state.user.accessRoutes
}
export default getters
